export const _label = /(?!\s*\])(?:\\.|[^[\]\\])+/
